const formatPrice = (currency, value) => Intl.NumberFormat("en-US", {
    currency,
    minimumFractionDigits: 2,
    style: "currency",
}).format(value);

const Money = ({ value }) => {
    const amount = parseFloat(value?.amount);
    if (Number.isNaN(amount)) return "-";

    const rounded = Math.ceil(parseFloat(value.amount) * 100) / 100;
    return formatPrice(value.currencyCode, rounded);
};
export default Money;
